import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { ServiceType } from '@uipath/portal-shell-util';

import { LogType } from '../models/logger';

export enum STORAGE_KEYS {
    PORTAL_ACCOUNT = 'PORTAL_ACCOUNT',
    PORTAL_CURRENT_TENANT = 'PORTAL_CURRENT_TENANT',
    PORTAL_SHELL_PERSONA = 'PORTAL_SHELL_PERSONA',
    PORTAL_SHELL_PERSONA_LAST_REFETCHED = 'PORTAL_SHELL_PERSONA_LAST_REFETCHED',
    PORTAL_SHELL_ACCOUNT_AND_TENANTS_LAST_REFETCHED = 'PORTAL_SHELL_ACCOUNT_AND_TENANTS_LAST_REFETCHED',
    PORTAL_GRAVATAR = 'PORTAL_GRAVATAR',
    PORTAL_SHELL_FLAGS_LAST_REFETCHED = 'PORTAL_SHELL_FLAGS_LAST_REFETCHED',
    PORTAL_FEATURE_FLAGS = 'PORTAL_FEATURE_FLAGS',
    PORTAL_SHELL_LOCALE_LAST_REFETCHED = 'PORTAL_SHELL_LOCALE_LAST_REFETCHED',
    PORTAL_SHELL_THEME_LAST_REFETCHED = 'PORTAL_SHELL_THEME_LAST_REFETCHED',
}

export enum Scope {
    Global = 'global',
    Tenant = 'tenant',
}

const SHARED_PENDO_API_KEY = '28a6b07f-b80b-474b-7c38-73dada1ee0a4';

export const PendoApiKey = {
    [ServiceType.cloudRpa]: SHARED_PENDO_API_KEY,
    [ServiceType.insights]: SHARED_PENDO_API_KEY,
    [ServiceType.automationHub]: SHARED_PENDO_API_KEY,
    [ServiceType.processMining]: 'd15cf892-cd1e-4e14-508a-b07b9fa7bff4',
    [ServiceType.apps]: '2b1fd049-7787-4b7f-5b19-ccffabc100fb',
    [ServiceType.orchestrator]: SHARED_PENDO_API_KEY,
    [ServiceType.roboticsOps]: SHARED_PENDO_API_KEY,
    [ServiceType.integrations]: SHARED_PENDO_API_KEY,
    [ServiceType.connectorbuilder]: SHARED_PENDO_API_KEY,
    [ServiceType.provisioning]: SHARED_PENDO_API_KEY,
    [ServiceType.automationStore]: SHARED_PENDO_API_KEY,
    [ServiceType.taskMining]: '6d4bc7c8-67a9-45bd-433c-946db93ded15',
    [ServiceType.studio]: SHARED_PENDO_API_KEY,
    [ServiceType.dataservice]: SHARED_PENDO_API_KEY,
};

export const LocalizationHeaderName = 'X-UIPATH-Localization';
export const TenantHeaderKey = 'X-UiPath-Internal-TenantId';

export enum BuiltInGroups {
    Admin = '35551807-06b1-4cda-90a1-2fb84851eee7',
    Everyone = 'ce684f6f-5af3-4e43-8516-1adad6e98fc9',
    AutomationDevelopers = '4d161738-7204-4794-b839-8f7fed28366c',
    AutomationUsers = 'cdc34b5b-77d2-4ae1-9744-209d21ce557d',
}

export enum AccountType {
    Enterprise = 'ENTERPRISE',
    Community = 'COMMUNITY',
    Trial = 'TRIAL',
    Free = 'FREEKIT',
    Pro = 'PRO',
    ProTrial = 'PRO-TRIAL',
}

export const severityLevelToLogLevel: { [severityLevel: number]: LogType } = {
    [SeverityLevel.Verbose]: 'debug',
    [SeverityLevel.Information]: 'info',
    [SeverityLevel.Warning]: 'warn',
    [SeverityLevel.Error]: 'error',
    [SeverityLevel.Critical]: 'error',
};

export enum LanguageCodes {
    en = 'en',
    zhCn = 'zh-cn',
    zhTw = 'zh-tw',
    es = 'es',
    esMx = 'es-mx',
    pt = 'pt',
    ptBr = 'pt-br',
    ja = 'ja',
    de = 'de',
    fr = 'fr',
    ko = 'ko',
    ru = 'ru',
    tr = 'tr',
}

export type LanguageCode = `${LanguageCodes}`;

export enum AuthSettings {
    IdleTimeoutDuration = 'IdleTimeoutDuration',
    AllowConcurrentBrowserSessions = 'AllowConcurrentBrowserSessions',
}
